import React, { useState } from 'react';
import FormLayout from '../components/FormLayout';
import VehicleForm from '../components/VehicleForm';
import { omruilFormConfig } from '../config/forms';
import { t } from '../locales/nl';

const OmruilForm: React.FC = () => {
  const [currentSection, setCurrentSection] = useState<string>('');

  return (
    <FormLayout 
      title={t.omruilFormTitle}
      currentSection={currentSection}
    >
      <VehicleForm 
        formType="omruil"
        formConfig={omruilFormConfig}
        onSectionChange={setCurrentSection}
      />
    </FormLayout>
  );
};

export default OmruilForm;